import { LocationService } from './components/Location/LocationService';

interface environment {
  cspAllowedUrls: string[];
  oktaClientId: string;
  oktaApiKey: string;
  oktaOrgUrl: string;
  amplitudeApiKey?: string;
  endpoints: {
    canConfig: string;
    graphQlManager: string;
    irisGroups: string;
    irisAssetGroups: string;
    machine: string;
    telematicsDevice: string;
    telematicsDeviceV2: string;
    units: string;
    deviceAccessControl: string;
    asset: string;
    assetV2: string;
  };
}

type EnvironmentType = 'manitouProd' | 'prod' | 'stage' | 'dev' | 'local';

let environments: { [key: string]: environment } = {
  local: {
    cspAllowedUrls: [
      'https://*.trackunit.com/',
      'https://trackunit-portal.okta.com/',
      'https://api.amplitude.com/',
      'https://8kqztgrd458c.statuspage.io/'
    ],
    oktaClientId: '0oa3tk0dt9wEPF6tt357',
    oktaApiKey: 'aus2u1ctyrhWjlJXa356',
    oktaOrgUrl: 'https://trackunit-portal.okta.com',
    //oktaApiKey: 'aus2u3jix1dWU7fwt356', // Temporary to test Okta SSO
    //    amplitudeApiKey: undefined,
    amplitudeApiKey: 'f1c4f26b44a3d6481e2a034dac19b24c', // trufflehog:ignore
    endpoints: {
      canConfig: 'https://dev.awsapi.trackunit.com/public/api/can-config',
      graphQlManager: 'https://dev.awsapi.trackunit.com/public/api/gql',
      irisGroups: 'https://dev.awsapi.trackunit.com/api/organization/v1/groups',
      irisAssetGroups:
        'https://dev.awsapi.trackunit.com/api/organization/v1/assets',
      machine: 'https://dev.awsapi.trackunit.com/public/api/machine',
      telematicsDevice:
        'https://dev.awsapi.trackunit.com/public/api/telematics-device-api',
      telematicsDeviceV2:
        'https://dev.awsapi.trackunit.com/public/api/telematics-device-api/v2',
      deviceAccessControl:
        'https://dev.awsapi.trackunit.com/public/api/device-access-control-api/device-access-control',
      //units: 'https://irisapi-dev.trackunit.com/units/'
      units: 'https://irisapi.trackunit.com/units/', // Temporary to test Okta SSO
      asset: 'https://dev.awsapi.trackunit.com/api/asset/v2beta1/assets',
      assetV2: 'https://dev.awsapi.trackunit.com/api/asset/v2/assets'
    }
  },
  dev: {
    cspAllowedUrls: [
      'https://identity.dev.iris.trackunit.com/',
      'http://localhost:3000/',
      'https://*.trackunit.com/',
      'https://trackunit-portal.okta.com/',
      'https://api.amplitude.com/',
      'https://8kqztgrd458c.statuspage.io/'
    ],
    oktaClientId: '0oa1q4m1cbpI97DlZ358',
    oktaApiKey: 'ausj7eh9zeiFhLk4m357',
    oktaOrgUrl: 'https://identity.dev.iris.trackunit.com',
    //oktaApiKey: 'aus2u3jix1dWU7fwt356', // Temporary to test Okta SSO
    amplitudeApiKey: 'f1c4f26b44a3d6481e2a034dac19b24c', // trufflehog:ignore
    endpoints: {
      canConfig: 'https://dev.awsapi.trackunit.com/public/api/can-config',
      graphQlManager: 'https://dev.awsapi.trackunit.com/public/api/gql',
      irisGroups: 'https://dev.awsapi.trackunit.com/api/organization/v1/groups',
      irisAssetGroups:
        'https://dev.awsapi.trackunit.com/api/organization/v1/assets',
      machine: 'https://dev.awsapi.trackunit.com/public/api/machine',
      telematicsDevice:
        'https://dev.awsapi.trackunit.com/public/api/telematics-device-api',
      telematicsDeviceV2:
        'https://dev.awsapi.trackunit.com/public/api/telematics-device-api/v2',
      deviceAccessControl:
        'https://dev.awsapi.trackunit.com/public/api/device-access-control-api/device-access-control',
      // units: 'https://irisapi-dev.trackunit.com/units/'
      units: 'https://irisapi.trackunit.com/units/', // Temporary to test Okta SSO
      asset: 'https://dev.awsapi.trackunit.com/api/asset/v2beta1/assets',
      assetV2: 'https://dev.awsapi.trackunit.com/api/asset/v2/assets'
    }
  },
  stage: {
    cspAllowedUrls: [
      'https://*.trackunit.com/',
      'https://trackunit-portal.okta.com/',
      'https://api.amplitude.com/',
      'https://8kqztgrd458c.statuspage.io/'
    ],
    oktaClientId: '0oa3tk11ccEINvnzo357',
    oktaApiKey: 'aus2u2bi02B7IYj00356',
    oktaOrgUrl: 'https://trackunit-portal.okta.com',
    amplitudeApiKey: '24b4b83775e4280da8d09d59973ba43c', // trufflehog:ignore
    endpoints: {
      canConfig: 'https://stage.awsapi.trackunit.com/public/api/can-config',
      graphQlManager: 'https://stage.awsapi.trackunit.com/public/api/gql',
      irisGroups:
        'https://stage.awsapi.trackunit.com/api/organization/v1/groups',
      irisAssetGroups:
        'https://stage.awsapi.trackunit.com/api/organization/v1/assets',
      machine: 'https://stage.awsapi.trackunit.com/public/api/machine',
      telematicsDevice:
        'https://stage.awsapi.trackunit.com/public/api/telematics-device-api',
      telematicsDeviceV2:
        'https://stage.awsapi.trackunit.com/public/api/telematics-device-api/v2',
      deviceAccessControl:
        'https://stage.awsapi.trackunit.com/public/api/device-access-control-api/device-access-control',
      units: 'https://irisapi-dev.trackunit.com/units/',
      asset: 'https://stage.awsapi.trackunit.com/api/asset/v2beta1/assets',
      assetV2: 'https://stage.awsapi.trackunit.com/api/asset/v2/assets'
    }
  },
  prod: {
    cspAllowedUrls: [
      'https://*.trackunit.com/',
      'https://trackunit-portal.okta.com/',
      'https://verify-easymanager.manitou.com/',
      'https://api.amplitude.com/',
      'https://8kqztgrd458c.statuspage.io/'
    ],
    oktaClientId: '0oa3tk8l7ay8qRLG9357',
    oktaApiKey: 'aus2u3jix1dWU7fwt356',
    oktaOrgUrl: 'https://identity.iris.trackunit.com',
    amplitudeApiKey: '02a01403bf674bc3ff676471fda11874', // trufflehog:ignore
    endpoints: {
      canConfig: 'https://prod.awsapi.trackunit.com/public/api/can-config',
      graphQlManager: 'https://iris.trackunit.com/api/graphql',
      irisGroups: 'https://iris.trackunit.com/api/organization/v1/groups',
      irisAssetGroups: 'https://iris.trackunit.com/api/organization/v1/assets',
      machine: 'https://prod.awsapi.trackunit.com/public/api/machine',
      telematicsDevice:
        'https://prod.awsapi.trackunit.com/public/api/telematics-device-api',
      telematicsDeviceV2:
        'https://prod.awsapi.trackunit.com/public/api/telematics-device-api/v2',
      deviceAccessControl:
        'https://prod.awsapi.trackunit.com/public/api/device-access-control-api/device-access-control',
      units: 'https://irisapi.trackunit.com/units/',
      asset: 'https://prod.awsapi.trackunit.com/api/asset/v2beta1/assets',
      assetV2: 'https://prod.awsapi.trackunit.com/api/asset/v2/assets'
    }
  }
};

environments['manitouProd'] = {
  ...environments['prod']
  //oktaClientId: '0oa3tk0dt9wEPF6tt357' // Feature request could be to override the Okta client id to restrict user access
};

export const getEnviroment = (): environment => {
  const environmentType = detectEnvironment();

  if (environmentType && environmentType in environments) {
    return environments[environmentType] as environment;
  } else {
    throw new Error('Not able to map url to environment');
  }
};

function detectEnvironment(): EnvironmentType {
  const host = window.location.host;

  if (LocationService.isServedOnLocalhost()) {
    /* To run locally against prod, then also change the oktaClientId to the local one */
    return 'dev';
  }

  if (
    LocationService.isServedOnManitou() ||
    LocationService.isManitouTestUrl()
  ) {
    return 'manitouProd';
  }

  if (
    LocationService.isServedOnTrackunit() ||
    LocationService.isServedOnTemporaryInstall()
  ) {
    return 'prod';
  }

  const k8sEnvRegex = /(?:new-verify|verify).(prod|stage|dev).awsapi.trackunit.com/i;
  const hostMatches = k8sEnvRegex.exec(host);
  if (hostMatches != null) {
    return hostMatches[1] as EnvironmentType; // Index 1 in a result list is always the first matched group
  }
  throw new Error('Could not determine which endpoint to use');
}
